import { render } from "./EditPost.vue?vue&type=template&id=1263a7a9"
import script from "./EditPost.vue?vue&type=script&lang=js"
export * from "./EditPost.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Devs\\Fullstack\\NewDeal\\vue_app_api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__